/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import type { ComponentRendererConfig } from '../shared/Types';
import { PlatformText } from './components/PlatformText';
import { PlatformLocaleText } from './components/PlatformLocaleText';
import { PlatformAudio } from './components/PlatformAudio';
import { PlatformVideo } from './components/PlatformVideo';
import { PlatformImage } from './components/PlatformImage';

/**
 * Configuration mapping platform component dtypes to their Chakra UI components
 */
export const PlatformComponentRenderer: ComponentRendererConfig = {
  TEXT: PlatformText,
  LOCALE_TEXT: PlatformLocaleText,
  AUDIO: PlatformAudio,
  VIDEO: PlatformVideo,
  IMAGE: PlatformImage,
};
